import React from "react"
import Recherche from "./Recherche";
import { useSelector } from "react-redux"
import { Table } from "semantic-ui-react";
import Project from "./Project";

const ProjectList = (props) => {
  const projects = useSelector(state => state.project.projects);

  const openPage = (page) => {
    props.openPage(page);
  }

  const renderProjects = () => {
    if (projects) {
      return (
        <Table.Body>
          {projects.map(project => (
            <Project key={project.id} project={project} openPage={() => openPage} />
          ))}
        </Table.Body>
      );
    } else {
      return undefined;
    }
  }

  return (
    <div className="full-width">
      <div className="recherche"><Recherche/></div>
            <Table selectable >
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>Custom Identifier</Table.HeaderCell>
                  <Table.HeaderCell>Acronym</Table.HeaderCell>
                  <Table.HeaderCell>Project Status</Table.HeaderCell>
                  <Table.HeaderCell>SpecificObjectiveCode</Table.HeaderCell>
                  <Table.HeaderCell>programmePriorityCode</Table.HeaderCell>
                  <Table.HeaderCell></Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              {renderProjects()}
            </Table>
    </div>
  );
}

export default ProjectList;